import { Component, OnInit, Input, Output, ViewChild } from '@angular/core';
import { GridComponent, GridDataResult, DataStateChangeEvent, PageChangeEvent, SelectionEvent } from '@progress/kendo-angular-grid';
import { State, process } from '@progress/kendo-data-query';
import { Subscription, Subject, Observable } from 'rxjs'
import { map } from 'rxjs/operators';
import { DateTime } from 'typescript-dotnet-es6/System/Time/DateTime'
import { format } from 'typescript-dotnet-es6/System/Text/Utility'
import { Validators, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { AuditStd_AuditProperty } from '../../../../core/sampleAuditStd_AuditPropertyData';
import { AuditStdImport } from '../utilities/auditstd-import-model';
import { UpdateStateService, AddDaysToDate } from '../../../../core';
import { AuditStdEdit, Property, ImportStatus, Error as pError, Warning, Info } from '../utilities/auditstd-edit-model';
import { CorporateDateRules, initDateRangeRules } from '../utilities/corporateDateRules'
import { AuditStd_DateRangeRules } from '../../../../core/models/rate-audit-settings-model';
@Component({
  selector: 'app-property-edit',
  templateUrl: './property-edit.component.html',
  styleUrls: ['./property-edit.component.scss']
})
export class PropertyEditComponent implements OnInit {

  constructor(private formBuilder: UntypedFormBuilder,
    private updateStateService: UpdateStateService<boolean>,
  ) {
    this.viewObserver = this.viewDataSubject.asObservable();
  }

  ngOnInit() {
    this.selectedID.push(0);
    const firstValidStart = AddDaysToDate(this.now(), 1);
    this.startDate = firstValidStart.toJsDate();
    this.startDateMin = firstValidStart.toJsDate();
    this.startDateMax = AddDaysToDate(this.now(), 330).toJsDate();
    this.endDate = new DateTime(new Date(DateTime.now.year, 11, 31)).toJsDate();
    this.endDateMin = AddDaysToDate(this.now(), 5).toJsDate();
    this.endDateMax = AddDaysToDate(this.now(), 330).toJsDate();
    if (this.endDateMax < this.endDate) {
      this.endDateMax = new DateTime(new Date(DateTime.now.year, 11, 31)).toJsDate();
    }
  }
  now: () => DateTime = () => { return DateTime.now };

  @ViewChild('kendo-grid', { static: false }) kendoGridCtrl: GridComponent;
  @Input("toConfirmDlg") toConfirmDlg: { confirmDlg: (msg: string, msg2: string, title: string, cancelButton?: boolean) => Observable<boolean> };
  startDate: Date;
  startDateMin: Date;
  startDateMax: Date;
  endDate: Date;
  endDateMin: Date;
  endDateMax: Date;

  dropdownPopupSettings: string = "";
  dateRankSelection: string = "First";
  dateRankOptions: { id: number, desc: string }[] = [{ id: 1, desc: 'First' }, { id: 2, desc: 'Second' }, { id: 3, desc: 'Third' }, { id: 4, desc: 'Fourth' }];
  daySelection: string = "Monday";
  dayOptions: { id: number, desc: string }[] = [{ id: 1, desc: 'Monday' }, { id: 2, desc: 'Tuesday' }, { id: 3, desc: 'Wednesday' }, { id: 4, desc: 'Thursday' }, { id: 5, desc: 'Friday' }, { id: 6, desc: 'Saturday' }, { id: 0, desc: 'Sunday' }];
  activeDateSelectionRule: CorporateDateRules.DateSelectionRule = new CorporateDateRules.DateSelectionRule();
  originalDateSelectionRule: CorporateDateRules.DateSelectionRule;

  currencyCodes: any;

  editedAudit: AuditStdEdit = new AuditStdEdit(new AuditStdImport(), false, "");
  _view: GridDataResult = { data: [], total: 0 };
  public viewObserver: Observable<GridDataResult>;
  public viewDataSubject: Subject<GridDataResult> = new Subject<GridDataResult>();
  public set view(data: GridDataResult) {
    this._view = data;
    this.viewDataSubject.next(this._view)

  }

  norecords: boolean = true;
  //gridData: any[] = this.editedAudit.property;
  public state: State = {
    skip: 0,
    take: 6
  };
  selectedID: any[] = [];

  showAllValid: boolean = true;
  showAllErrors: boolean = true;
  showAllWarnings: boolean = true;
  showAllMessages: boolean = true;

  showErrors: boolean = true;
  showWarnings: boolean = true;
  showMessages: boolean = true;

  errorList: pError[] = [];
  warningList: Warning[] = [];
  messageList: Info[] = [];

  pageChange(event: PageChangeEvent): void {
    this.state.skip = event.skip;
    //kendo will call dataStateChange() not needed=> this.loadItems();
  }
  sorted: string = "";
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.sorted = "";
    //this.selectedID=[];
    this.sorted = (state.sort.find(e => e.dir === 'asc' || e.dir == 'desc') || { 'field': '' }).field;
    this.loadItems();
  }

  public dynamicSort<T>(property: string, dir: string): (a: T, b: T) => number {
    let sortOrder = (dir === "desc") ? -1 : 1;
    return (a, b) => {
      let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    }
  }
  removeRow(dataItem: Property) {
    let i = dataItem.index;
    let indx = this.editedAudit.property.findIndex(q => q.index == i);
    this.editedAudit.property.splice(indx, 1);
    this.updateFilter();
  }
  updateFilter() {
    //this.selectedID=[];
    this.loadItems();
  }
  filteredAndSorted: Property[];
  private loadItems(): void {
    this.isBusy(true);
    try {

      let data = this.editedAudit.property;
      if (!this.showAllValid || !this.showAllErrors || !this.showAllMessages || !this.showAllWarnings) {
        data = data.filter((property) => {
          let show =
            (this.showAllErrors && property.Errors.length > 0) ||
            (this.showAllMessages && property.Information.length > 0) ||
            (this.showAllWarnings && property.Warnings.length > 0) ||
            (this.showAllValid && ((property.Errors.length + property.Warnings.length + property.Information.length) == 0));
          return show;
        })
      }
      let state = this.state;
      if (state.sort && state.sort.length > 0) {
        let srt = state.sort[0];
        let srtFn = this.dynamicSort(srt.field, srt.dir);
        data = data.sort(srtFn);
      }
      this.filteredAndSorted = data;
      if (this.state.skip >= data.length) {
        this.state.skip = data.length - this.state.take;
        this.state.skip = this.state.skip < 0 ? 0 : this.state.skip;
      }


      let pageDate = data.slice(this.state.skip, this.state.skip + this.state.take);
      this.view = {
        data: pageDate,
        total: data.length
      };

      if (this.selectedID.length > 0) {
        if (data.length > 0) {
          if (this.selectedID[0] >= data.length) {
            this.selectedID[0] = data.length - 1;
          }
          this.switchToProperty(this.selectedID[0])
        }
      } else {
        this.selectedID = [];
        this.switchToProperty(-1);
      }
    } catch (error) {
      console.log(error);
    }
    //setTimeout(()=>{this.isBusy(false);}, 1000);
    this.isBusy(false);
  }
  click() {

  }
  checkStartDate() {
    const date: Date = this.startDate;
    if (date < this.startDateMin)
      this.startDate = this.startDateMin;
    else if (date > this.startDateMax)
      this.startDate = this.startDateMax;
  }

  checkEndDate() {
    const date: Date = this.endDate;
    if (date < this.endDateMin)
      this.endDate = this.endDateMin;
    else if (date > this.endDateMax)
      this.endDate = this.endDateMax;
  }


  public assignValues(target: any, source: any): void {
    source.AmadeusChainCode = source.AmadeusChainCode.replace(/\s+/g, '').toUpperCase();
    source.AmadeusPropCode = source.AmadeusPropCode.replace(/\s+/g, '').toUpperCase();
    source.ApolloChainCode = source.ApolloChainCode.replace(/\s+/g, '').toUpperCase();
    source.ApolloPropCode = source.ApolloPropCode.replace(/\s+/g, '').toUpperCase();
    source.GalileoChainCode = source.GalileoChainCode.replace(/\s+/g, '').toUpperCase();
    source.GalileoPropCode = source.GalileoPropCode.replace(/\s+/g, '').toUpperCase();
    source.SabreChainCode = source.SabreChainCode.replace(/\s+/g, '').toUpperCase();
    source.SabrePropCode = source.SabrePropCode.replace(/\s+/g, '').toUpperCase();
    source.WorldspanChainCode = source.WorldspanChainCode.replace(/\s+/g, '').toUpperCase();
    source.WorldspanPropCode = source.WorldspanPropCode.replace(/\s+/g, '').toUpperCase();

    Object.assign(target, source);
  }

  public cellClickHandler({ sender, rowIndex, columnIndex, dataItem }) {


    if (!dataItem.LoadedFromOriginal) {
      sender.editCell(rowIndex, columnIndex, this.createFormGroup(dataItem));
    }


  }

  public cellCloseHandler(args: any) {
    const { formGroup, dataItem } = args;

    if (!formGroup.valid) {
      // prevent closing the edited cell if there are invalid values.
      args.preventDefault();
    } else if (formGroup.dirty) {
      this.assignValues(dataItem, formGroup.value);
    }
  }

  public createFormGroup(dataItem: any): UntypedFormGroup {
    return this.formBuilder.group({
      'AmadeusChainCode': [dataItem.AmadeusChainCode, Validators.maxLength(3)],
      'AmadeusPropCode': [dataItem.AmadeusPropCode, Validators.maxLength(10)],
      'ApolloChainCode': [dataItem.ApolloChainCode, Validators.maxLength(3)],
      'ApolloPropCode': [dataItem.ApolloPropCode, Validators.maxLength(10)],
      'GalileoChainCode': [dataItem.GalileoChainCode, Validators.maxLength(3)],
      'GalileoPropCode': [dataItem.GalileoPropCode, Validators.maxLength(10)],
      'SabreChainCode': [dataItem.SabreChainCode, Validators.maxLength(3)],
      'SabrePropCode': [dataItem.SabrePropCode, Validators.maxLength(10)],
      'WorldspanChainCode': [dataItem.WorldspanChainCode, Validators.maxLength(3)],
      'WorldspanPropCode': [dataItem.WorldspanPropCode, Validators.maxLength(10)]
    });
  }

  propertySelection(event: SelectionEvent) {
    this.switchToProperty(event.selectedRows ? event.selectedRows[0].index : -1);
  }
  switchToProperty(index: number) {
    if (index >= 0) {
      let p: Property = this.filteredAndSorted[index];
      this.errorList = p.Errors;
      this.warningList = p.Warnings;
      this.messageList = p.Information;
    } else {
      this.errorList = [];
      this.warningList = [];
      this.messageList = [];
    }
  }
  setOriginalDateSelectionRule(originalDateSelectionRule: AuditStd_DateRangeRules) {
    this.originalDateSelectionRule = new CorporateDateRules.DateSelectionRule();
    this.activeDateSelectionRule = initDateRangeRules(this.originalDateSelectionRule, originalDateSelectionRule);
  }

  GenerateDatesUsingSeasonRangeControls() {
    this.reapplyDateRules(false);
  }
  GenerateDatesUsingOriginalSeason1() {
    this.reapplyDateRules(true);
  }
  RestoreOriginalDayMonthRules() {
    this.activeDateSelectionRule = { ...this.originalDateSelectionRule }
  }
  reapplyDateRules(useOriginalSeasonOne: boolean) {
    this.editedAudit.reapplyDateRulesToProperties(new DateTime(this.startDate), new DateTime(this.endDate), this.activeDateSelectionRule, useOriginalSeasonOne);
    this.loadItems();
  }

  isBusy(enable: boolean) {
    this.updateStateService.updateState(enable)
  }
  OnEnterFromNext() {
    //set date values, but not the maximum and minimum because those are set in
    // ngOnInit and don't need to change
    const firstValidStart = AddDaysToDate(this.now(), 1);
    this.startDate = firstValidStart.toJsDate();
    this.endDate = new DateTime(new Date(DateTime.now.year, 11, 31)).toJsDate();
    let dates:{earliestStart:DateTime,latestEnd:DateTime} = this.editedAudit.GetSeasonRange(this.endDate);
    if(dates.latestEnd.toJsDate()>this.endDate){
      this.endDate = dates.latestEnd.toJsDate();
    }
    if(dates.earliestStart.toJsDate()<this.startDate){
      this.startDate = dates.earliestStart.toJsDate();
    }

    this.editedAudit.applyDateRulesToPropertiesOnEntry(this.activeDateSelectionRule);
    let data = this.editedAudit.property;
    this.norecords = data.length ? false : true;
    this.selectedID = this.norecords ? [] : [0];
    this.loadItems();
    //this.gridData = this.editedAudit.property; //trigger refresh
    //this.isBusy(false);
  }
  hasError(property: Property) {
    if (property && property.Errors)
      return property.Errors.length > 0;
    return false;
  }
  hasWarning(property: Property) {
    if (property && property.Warnings)
      return property.Warnings.length > 0;
    return false;
  }
  hasInfo(property: Property) {
    if (property && property.Information)
      return property.Information.length > 0;
    return false;
  }

  validateBeforeProceedingToNextStep(): boolean {
    if (this.editedAudit.property.some(property => property.Errors.length > 0)) {
      this.toConfirmDlg.confirmDlg("The import contains error(s) that must be repaired or removed before processing can be scheduled"
        , "", "Error", false)
        .subscribe(a => a == a);
      return false;
    }
    if (this.editedAudit.property.filter(q => q.LoadedFromOriginal == false).length == 0) {
      this.toConfirmDlg.confirmDlg("At least one property should be defined to be audited before you can proceed. "
        , "", "Error", false)
        .subscribe(a => a == a);
      return false;
    }

    return true;
  }
}
